import type { HTMLAttributes } from 'react';
import type { OnboardingStepState } from '../../lib/models/onboarding';

export interface StepMarkerProps extends HTMLAttributes<HTMLSpanElement> {
  /** Lifecycle state — drives glyph + fill. */
  state: OnboardingStepState;
}

const GLYPH: Record<OnboardingStepState, string> = {
  todo: '○',
  done: '✓',
  skipped: '↗'
};

/**
 * 28px bordered square step marker — the status box on the dashboard
 * onboarding checklist rows. `done` fills solid (inverted), `skipped` goes
 * dashed + muted. Matches the `.step-status` box in
 * `../web-mock/features/dashboard/dashboard.html`.
 */
export function StepMarker({ state, className, ...rest }: StepMarkerProps) {
  const cls = ['pn-step-marker', `pn-step-marker-${state}`, className]
    .filter(Boolean)
    .join(' ');
  return (
    <span className={cls} aria-hidden {...rest}>
      {GLYPH[state]}
    </span>
  );
}
